import AnalyseAndImplement from './AnalyseAndImplementOptions';
import Threshold from './ThresholdOptions';

const FieldOptions = {
    AnalyseAndImplement,
    Threshold,
};
export default FieldOptions;
